import { getImageUrl } from "../../../config/s3Config";
import "./achievements.css";

const Achievements = () => {
    return (
    <>
         {/* Achievements & Accreditations (Modern) */}
      <section className="achievements modern" id="achievements">
      <div className="achv-decor achv-decor-a" />
      <div className="achv-decor achv-decor-b" />
      <div className="container">
        <div className="section-header compactish">
          <div className="eyebrow alt">Recognition</div>
          <h2>Achievements & Accreditations</h2>
          <p>Global standards, quality assurance and industry partnerships validating our journey</p>
        </div>

        <div className="achv-stats">
          {[{n:'15+',l:'Years of Excellence'},{n:'50+',l:'Centres Island-wide'},{n:'1000s',l:'Successful Alumni'},{n:'10+',l:'Key Accreditations'}].map(s=>
            <div key={s.l} className="achv-stat"><strong>{s.n}</strong><span>{s.l}</span></div>
          )}
        </div>

        <div className="achv-iso-showcase" aria-label="ISO certification">
          <div className="achv-iso-panel">
            <span className="achv-iso-badge">ISO Certified</span>
            <div className="achv-iso-image-wrap">
              <img
                src={getImageUrl("/images/iso/isoImage1.jpeg")}
                alt="SDTI ISO quality certification"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="achv-grid">
          {[
            { img: getImageUrl('/images/logos/ugc_recognized.png'), label:'UGC Recognized', type:'Academic' },
            { img: getImageUrl('/images/logos/iso.png'), label:'ISO Certified', type:'Quality' },
            { img: getImageUrl('/images/logos/iqa logo png.png'), label:'IQA Accredited', type:'Quality' },
            { img: getImageUrl('/images/logos/IIC1.png'), label:'IIC Certified', type:'Innovation' },
            { img: getImageUrl('/images/logos/SILVER-WES-logo-NEW.png'), label:'WES Silver Partner', type:'Global' },
            { img: getImageUrl('/images/logos/sdti.png'), label:'SDTI Campus', type:'Identity' },
                { img: getImageUrl('/images/logos/HQ.png'), label: 'Quality Assured', type: 'Quality' },
                { img: getImageUrl('/images/logos/193375.png'), label: 'UGC Recognized', type: 'Quality' },
            { img: getImageUrl('/images/logos/LOGO-1-927x1024.png'), label: 'UGC Recognized', type: 'Quality' },
  
              ].map((l, i) => (
            <div key={l.label} className="achv-card pop-in" style={{animationDelay: `${0.05*i}s`}}>
              <div className="achv-card-front">
                <div className="achv-logo-wrap"><img src={l.img} alt={l.label} loading="lazy" /></div>
                <h4>{l.label}</h4>
                <span className="achv-tag">{l.type}</span>
              </div>
              <div className="achv-card-back">
                <p>{l.label} reflects our ongoing commitment to internationally benchmarked educational quality.</p>
              </div>
            </div>
          ))}
        </div>

       
      </div>
    </section >
    </>
    )
}

export default Achievements